import React, {useState, useEffect, Fragment} from 'react'
import {connect} from 'react-redux'
import Swal from "sweetalert2"
import SideMenu from "./SideMenu"
import styles from "./SideZone.scss"
import {motion} from "framer-motion"

import LayersPanel from "../LeftPanel/LayersPanel/LayersPanel"
import DataPanel from "../LeftPanel/DataPanel/DataPanel"
import LibraryPanel from "../LeftPanel/LibraryPanel"
import PrintPanel from "../LeftPanel/PrintPanel"
import ResourcesPanel from "../LeftPanel/ResourcesPanel"
import FormsCallButtons from "../LeftPanel/DataPanel/FormsCallButtons"


const titleStyle = {
    "fontWeight": "600",
    "marginLeft": "13px",
    "marginRight": "43px"
}

const SideZone = (props)=> {

    const [menuIsOpen, setMenuIsOpen] = useState(true)
    const [dataPanelState, setDataPanelState] = useState(false)
    const [myWidth, setMyWidth] = useState(270)
    const [sideBareStyle, setSideBarStyle] = useState({'transition' : 'all 0.4s ease-out'})
    const [init, setInit] = useState()

    const toggleMenuVariants = {
        open:  {left: props.leftNavWidth+"px"},
        close: {left: "-600px" },
    }


/*
    useEffect(()=>{
        let draggNav = document.getElementById('draggNav');

        draggNav.addEventListener("touchstart", (evt)=>{
            evt.preventDefault();
        }, false);
        draggNav.addEventListener('touchmove',(e)=>{
            $('#sidebar').css('transition', 'none');
            (e.pageX>=50)?$('#sidebar').css("width", e.pageX + 2):null;
            props.setLeftPanelWidth(e.pageX)
        }, false )

        draggNav.addEventListener('touchend', (e)=>{
            $('#sidebar').css('transition',  'all 0.4s ease-out');
        }, false)

        $('#draggNav').mousedown(function(e) {
            e.preventDefault();
            $(document).mousemove(function(e) {
                //setSideBarStyle({'transition': 'none'})
                //console.log($('#sidebar').css("width").slice(0,-2));
                $('#sidebar').css('transition', 'none');
                (e.pageX>=50)?$('#sidebar').css("width", e.pageX + 2):null;
                props.setLeftPanelWidth(e.pageX)
            })
        });
        $(document).mouseup(function(e) {
            //$('#clickevent').html('in another mouseUp event' + i++);
            $('#sidebar').css('transition',  'all 0.4s ease-out');
            $(document).unbind('mousemove');
        });

    }, [])

 */

    useEffect(()=>{
        $('#sidebar').css("width", props.leftNavWidth);
    }, [props.leftPanelIsOpen])

    useEffect((e)=>{
        $('#sidebar').css("width", props.leftNavWidth);
        //console.log(props.leftNavWidth);
    }, [props.leftNavWidth])

    useEffect(()=>{

    }, [menuIsOpen])

    useEffect(()=>{
        displayPrintPanel()
    }, [props.printScreenCapt])

    useEffect(()=>{
        (props.showCurrentSection==='print')?preparPrint():null;
        (props.showCurrentSection==='search')?props.setLeftPanelOpen(false):null;
        (props.showCurrentSection==='data')?props.setLeftPanelOpen(true):null;
        //(props.showCurrentSection=='data')?$('#sideZone').css("width", "800px"):$('#sideZone').css("width", "420px");

    }, [props.showCurrentSection])


    useEffect(()=>{
       (props.showCurrentSection==='print')?props.togglePrintState(!props.printState):null;
       //displayPrintPanel();
        //props.showCurrentSection=='print')?preparPrint():null;
    }, [props.mapMoveEnd])




    const preparPrint=()=>{
        props.togglePrintState(true)
        /*
        $('.swal2-popup').css('color', '#d6d6d6');
        Swal.fire({
            title: '<p style="color:#FFFFFF;">Impression</p>',
            html: '<p style="color:#FFFFFF;">Préparation ...</p>',
            background: ' #303a3f',
            width: '15rem',
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            backdrop: false,
            allowEscapeKey: false,
        })
        Swal.showLoading()

         */
    }

    const displayPrintPanel=()=>{
        if(props.printScreenCapt){
            //Swal.close()
            props.togglePrintState(false)
        }
    }

    return (
        <div>
        {/*<SideMenu  sidebarstate={setMenuIsOpen}/>*/}
        <motion.div id="sideZone"
                    animate={  props.leftPanelIsOpen?"open":"close"}
                    transition={{ type: "easeInOut", duration: 0.7 }}
                    variants={toggleMenuVariants}
                    className={'vw-100'}
        >
            {(props.showCurrentSection==='layers')?
                <Fragment>

                    {/*<div className={"SideZoneTitle"}>
                        <div className={"SideZoneCloseBtn"}
                            onClick={(e)=> props.setLeftPanelOpen(false)}
                        >
                            <i className="bi bi-x" />
                        </div>
                    </div>*/}
                    <LayersPanel/>
                </Fragment>
                :null
            }
            {(props.showCurrentSection==='data')?
                <Fragment>
                    {/*<div className={"SideZoneTitle"}></div>*/}
                    <DataPanel />
                    {
                            (props.currentParcelles && props.currentParcelles.length > 0)
                                ? <FormsCallButtons/>
                                : null
                    }
                </Fragment>
                :null
            }
            {(props.showCurrentSection==='librairie')?

                <Fragment>
                    {/*<div className={"SideZoneTitle"}></div>*/}
                    <LibraryPanel />
                </Fragment>
                :null
            }
            {(props.showCurrentSection==='print')?
                <Fragment>
                    <h5 style={titleStyle} className={"border border-primary rounded p-2"}>Impression</h5>
                    <PrintPanel printScreenCapt={props.printScreenCapt}  mapref={props.mapRef}/>
                </Fragment>
                :null
            }
            {(props.showCurrentSection==='resources')?
                <Fragment>
                    <h5 style={titleStyle} className={"border border-primary rounded p-2"}>Ressources</h5>
                    <ResourcesPanel />
                </Fragment>
                :null
            }

        </motion.div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        mapRef: state.MapReducer.mapRef,
        mapMoveEnd : state.MapReducer.moveEnd,
        currentParcelles : state.MapReducer.currentParcelle,
        showDataPanel: state.LeftPanelReducer.showDataPanel,
        showLayerPanel: state.LeftPanelReducer.showLayerPanel,
        showCurrentSection: state.LeftPanelReducer.showCurrentSection,
        printScreenCapt: state.PrintReducer.printScreenCapt,
        centerMap: state.MapReducer.centerMap,
        printState: state.PrintReducer.printState,
        leftPanelWidth: state.LeftPanelReducer.leftNavWidth,
        leftPanelIsOpen: state.LeftPanelReducer.leftPanelOpen,
        leftNavWidth : state.LeftPanelReducer.leftNavWidth,
        leftMenuIsOpen: state.LeftPanelReducer.leftMenuIsOpen,
    }
}

const mapDispatchTProps = dispatch => {
    return {
        setShowDataPanel: (e) => dispatch( {type: 'SHOW_DATA_PANEL', data:e }),
        togglePrintState : (e) => dispatch({type: 'TOGGLE_PRINT_STATE', data:e }),
        setLeftPanelWidth : (e) => dispatch({type: 'SET_LEFT_PANEL_WIDTH', data:e }),
        setLeftPanelOpen : (e) => dispatch({type: 'SET_LEFT_PANEL_OPEN', data:e }),
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(SideZone);
